import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './inspirecommila_pagina.module.scss';
import logo from './src/raiz-logo.jpeg';

const WHATSAPP_URL =
    'https://wa.me/5531995461766?text=' +
    encodeURIComponent('Olá, vim pelo Instagram e quero reservar vaga na Imersão RAIZ.');

const Raiz_inspirecommila: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.page}>
            <div className={styles.sheet}>
                <div className={styles.header}>
                    <Link to="/inspirecommila" className={styles.back} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h1>Imersão</h1>
                </div>

                <figure className={`${styles.hero} ${styles.logo}`}>
                    <img src={logo} alt="Marca da Imersão RAIZ" />
                </figure>

                <div className={styles.corpo}>
                    <p className={styles.eyebrow}>RAIZ</p>
                    <h2 className={styles.titulo}>4 horas que podem mudar a forma como você se enxerga</h2>
                    <p className={styles.lead}>
                        Uma experiência on-line para identificar as raízes por trás de comportamentos, crenças e
                        padrões que continuam se repetindo.
                    </p>
                    <div className={styles.texto}>
                        <p>
                            RAIZ é intensa e prática. Saímos do comportamento aparente e olhamos para feridas
                            emocionais, crenças, máscaras de sobrevivência, identidade e reconstrução. Não é uma aula
                            para assistir: você é conduzida por reflexões e exercícios sobre a sua própria história.
                        </p>
                    </div>
                    <p className={styles.citacao}>
                        Porque muitas vezes tentamos mudar o fruto enquanto a raiz continua intacta.
                    </p>
                    <div className={styles.meta}>
                        <span>R$ 197</span>
                        <span>19 de setembro</span>
                        <span>On-line · 4 horas</span>
                    </div>
                    <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.cta}
                    >
                        Reservar minha vaga
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Raiz_inspirecommila;
